import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'antd';
import styles from './styles.module.scss';

const SignIn = props => {
  const handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
      signinUser,
      intl,
      siteLanguage
    } = props;

    validateFields((err, values) => {
      if (!err) {
        signinUser(intl, siteLanguage, {
          email: values.email.trim(),
          password: values.password
        });
      }
    });
  };
  const {
    form: { getFieldDecorator },
    intl,
    messages,
    signingIn,
    siteLanguage
  } = props;

  return (
    <Form hideRequiredMark onSubmit={handleSubmit}>
      <h2 className={styles.formTitle}>
        <FormattedMessage
          defaultMessage="Sign in to your account"
          id="App.Text.Signin"
        />
      </h2>

      <Form.Item
        colon={false}
        required={true}
        label={
          <FormattedMessage
            id="loginForm.UserNameInput"
            defaultMessage={'Email address'}
          />
        }
      >
        {getFieldDecorator('email', {
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.formErrorMsgInputUserName)
            }
          ]
        })(
          <Input
            autoFocus
            autoComplete="username email"
            size="large"
            data-dfs-people-id={'username-input'}
            placeholder="Email or phone number e.g. 233244000000"
          />
        )}
      </Form.Item>
      <Form.Item
        required={true}
        colon={false}
        label={
          <FormattedMessage
            id="loginForm.PasswordInput"
            defaultMessage={'Password'}
          />
        }
      >
        {getFieldDecorator('password', {
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.formErrorMsgInputPassword)
            }
          ]
        })(
          <Input.Password
            autoComplete="current-password"
            size="large"
            data-dfs-people-id={'password-input'}
            type="password"
            placeholder="Enter your password"
          />
        )}
      </Form.Item>

      <Form.Item>
        <Button
          className={styles.submitBtn}
          data-dfs-people-id={'signin-button'}
          block
          size="large"
          type="primary"
          htmlType="submit"
          loading={signingIn}
        >
          <FormattedMessage
            id="loginForm.SignInButton"
            defaultMessage={'Sign in'}
          />
        </Button>
      </Form.Item>

      <div className={styles.formLinks}>
        <Link
          data-dfs-people-id={'forgot-password-link'}
          to={`/${siteLanguage || 'en'}/forgotten-password`}
          className="auth_form_links_forgot"
        >
          <FormattedMessage
            id="loginScreen.ForgotPasswordLink"
            defaultMessage={'Forgot password?'}
          />
        </Link>
        <p>
          <span className={styles.noAccountText}>
            <FormattedMessage
              id="loginScreen.NoAccountText"
              defaultMessage={"Don't have an account?"}
            />
          </span>
          <Link
            data-dfs-people-id={'signup-link'}
            to={`/${siteLanguage || 'en'}/signup`}
          >
            {' '}
            <FormattedMessage
              id="loginScreen.CreateAccountLink"
              defaultMessage={'Create an account'}
            />
          </Link>
        </p>
      </div>
    </Form>
  );
};

SignIn.propTypes = {
  intl: PropTypes.any.isRequired,
  messages: PropTypes.any.isRequired,
  siteLanguage: PropTypes.string.isRequired,
  signingIn: PropTypes.bool.isRequired,
  signinUser: PropTypes.func.isRequired
};

const SignInForm = Form.create()(SignIn);

export default SignInForm;
